export const AVAILABLE_LOCALES = ['en', 'pl', 'de'] as const
export type AvailableLocale = (typeof AVAILABLE_LOCALES)[number]

export const DEFAULT_PER_PAGE = 25

export const SHIFTS = ['1', '2', '3', 'A'] as const
export type Shift = (typeof SHIFTS)[number]

export const CACHE_FOR = {
  LONG: '10m',
  DEFAULT: '5m',
} as const
